document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initVariantePicker();
  initGaleria();
  initFaq();
});

function initReveal() {
  var els = document.querySelectorAll('.bp-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('bp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bp-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-bp-count]');
  if (!els.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-bp-count')) || 0;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var value = target * (1 - Math.pow(1 - progress, 3));
          el.textContent = target % 1 === 0 ? Math.round(value) : value.toFixed(1);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initVariantePicker() {
  var root = document.querySelector('[data-bp-producto]');
  if (!root) return;
  var dataEl = root.querySelector('[data-bp-variantes-json]');
  if (!dataEl) return;
  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var swatches = root.querySelectorAll('[data-bp-swatch]');
  var idInput = root.querySelector('[data-bp-variant-id]');
  var priceEl = root.querySelector('[data-bp-precio]');
  var compareEl = root.querySelector('[data-bp-precio-comparado]');
  var submitBtn = root.querySelector('[data-bp-submit]');
  var mainImg = root.querySelector('[data-bp-imagen-principal]');

  function selectVariant(variant, imageUrl) {
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.priceFormatted;
    if (compareEl) {
      if (variant.compareAtPriceFormatted) {
        compareEl.textContent = variant.compareAtPriceFormatted;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? submitBtn.getAttribute('data-bp-texto-disponible')
        : submitBtn.getAttribute('data-bp-texto-agotado');
    }
    if (mainImg && imageUrl) mainImg.src = imageUrl;
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('bp-activo'); });
      swatch.classList.add('bp-activo');
      var variantId = swatch.getAttribute('data-bp-swatch');
      var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
      selectVariant(variant, swatch.getAttribute('data-bp-imagen'));
    });
  });
}

function initGaleria() {
  var root = document.querySelector('[data-bp-galeria]');
  if (!root) return;
  var main = root.querySelector('[data-bp-imagen-principal]');
  var thumbs = root.querySelectorAll('[data-bp-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('bp-activo'); });
      thumb.classList.add('bp-activo');
      if (main) main.src = thumb.getAttribute('data-bp-thumb-src');
    });
  });
}

function initFaq() {
  var items = document.querySelectorAll('[data-bp-faq-item]');
  items.forEach(function (item) {
    var trigger = item.querySelector('[data-bp-faq-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('bp-abierto');
      items.forEach(function (i) { i.classList.remove('bp-abierto'); });
      if (!isOpen) item.classList.add('bp-abierto');
    });
  });
}
